import moment from 'moment';
import routes from '../constants/routes';

export const trimName = (value) => (typeof value === 'string' ? value.trim() : value);

export function getFormData(object) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
}

export function getFromNowDateFormat(date) {
  let dateText = moment(date).fromNow(true);
  dateText += ' ago';
  switch (dateText) {
    case 'a minute ago':
      return '1 minute ago';
    case 'a day ago':
      return '1 day ago';
    case 'a month ago':
      return '1 month ago';
    case 'a year ago':
      return '1 year ago';
    default:
      return dateText;
  }
}

export function formatDate(date, withTime) {
  return moment(date).format(`MMM DD, yyyy ${withTime ? 'hh:mm A' : ''}`);
}
export function formatTimeFromDate(date) {
  return moment(date).format('hh:mm A');
}
export function shortFormatDate(date) {
  if (!date) return;

  const dateArray = date.split('-');
  return moment(`${dateArray[0]}-${dateArray[0]}-${dateArray[1]}`).isValid()
    ? moment(`${dateArray[0]}-${dateArray[0]}-${dateArray[1]}`)?.format('MMM yyyy')
    : '';
}

export const copyToClip = (text) => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  return true;
};

export const convertToSEO = (title) => {
  return title
    .trim()
    .replaceAll(' ', '-')
    .replaceAll('/', '-')
    .replaceAll(',', '')
    .toLocaleLowerCase();
};

export const downloadFile = (response) => {
  const url = window.URL.createObjectURL(new Blob([response]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', 'file.pdf');
  document.body.appendChild(link);
  link.click();
};

export const getYearList = (start, isValid18 = false) => {
  let currentYear = new Date().getFullYear();
  const years = [];

  if (isValid18) {
    currentYear -= 18;
  }
  for (let i = start; i <= currentYear; i++) {
    years.push(i);
  }
  return years;
};

export const highLightWord = (_TEXT, keyword) => {
  if (keyword) {
    const escapeRegExp = (string) => {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    const searchTerms = Array.isArray(keyword)
      ? [...new Set(keyword)]
      : [...new Set(keyword.split(' '))];

    for (const text of searchTerms) {
      if (text.trim().length > 0) {
        const escapedText = escapeRegExp(text.trim());
        const regex = new RegExp(`(^|\\s|\\W)(${escapedText})(\\s|\\W|$)`, 'gi');
        _TEXT = _TEXT?.replace(regex, (match, p1, p2, p3) => `${p1}<mark>${p2}</mark>${p3}`);
      }
    }
    return <span dangerouslySetInnerHTML={{ __html: _TEXT }} />;
  }
  return _TEXT;
};

export const getIpCountry = async () => {
  try {
    const response = await fetch(routes.getIp);
    if (!response.ok) {
      return false;
    }
    let data;
    try {
      data = await response.json();
    } catch (jsonError) {
      return false;
    }
    return data?.data?.hasOwnProperty('hasAccess') ? data.data.hasAccess : false;
  } catch (e) {
    return false;
  }
};

export const checkGlobalSectionError = (data, requiredFields) => {
  let hasGlobalError = false;
  if (
    !Array.isArray(data) ||
    !data.length ||
    !Array.isArray(requiredFields) ||
    !requiredFields.length
  ) {
    return { data: [], hasGlobalError };
  }

  const dataResult = data.map((element) => {
    const updatedElement = { ...element, hasError: false };
    for (const field of requiredFields) {
      const value = element[field];
      if (
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim().length === 0)
      ) {
        updatedElement.hasError = true;
        hasGlobalError = true;
      }
    }
    return updatedElement;
  });

  return { data: dataResult, hasGlobalError };
};

export const customHighlighterInAysnTypehead = (option, props) => {
  const normalizedSearch = props.text.trim().toLowerCase().replace(/\s+/g, '').replace(/,+/g, '');
  const normalizedLabel = option.label.toLowerCase().replace(/\s+/g, '').replace(/,+/g, '');
  const matchIndex = normalizedLabel.indexOf(normalizedSearch);

  if (matchIndex === -1) {
    return <span>{option.label}</span>;
  }
  const start = matchIndex;
  const end = start + normalizedSearch.length;

  return (
    <span className="d-block">
      {option.label.split('').map((char, idx) => {
        const normalizedIdx = option.label
          .slice(0, idx + 1)
          .replace(/\s+/g, '')
          .replace(/,+/g, '').length;

        let isHighlight = normalizedIdx > start && normalizedIdx <= end;

        if ((normalizedIdx >= end && char === ',') || (normalizedIdx >= end && char === ' ')) {
          isHighlight = false;
        }
        return (
          <span
            key={idx}
            style={{
              backgroundColor: isHighlight ? '#fff3cd' : 'transparent',
              display: 'inline-block'
            }}>
            {char === ' ' ? '\u00A0' : char}
          </span>
        );
      })}
    </span>
  );
};

export const getRangeStr = (min, max, { valueFormatter = (v) => v, suffix = '' } = {}) => {
  let value = '';

  if (min == null && max == null) {
    return '';
  }

  if (min == null) {
    value = `${valueFormatter(0)} - ${valueFormatter(max)}`;
  } else if (max == null) {
    if (min === 0) {
      return '';
    } else {
      value = `${valueFormatter(min)}+`;
    }
  } else if (min === max) {
    value = `${valueFormatter(min)}`;
  } else {
    value = `${valueFormatter(min)} - ${valueFormatter(max)}`;
  }

  return suffix ? `${value} ${suffix}` : value;
};
